import type { DriveManagementCopy } from '@/i18n/drives-management-copy-types';

export const ruDriveManagementCopy = {
  description: 'Общие файлы для команд, проектов и участников.',
  createDrive: 'Создать диск',
  createDriveTitle: 'Создать общий диск',
  driveName: 'Название диска',
  driveNameHint: 'Имя диска уникально и становится читаемым путём папки.',
  driveNameTaken: 'Диск с именем «{name}» уже существует.',
  driveNameReserved: 'Имя «{name}» зарезервировано. Выберите другое.',
  driveNameInvalid: 'Используйте в имени диска латинские буквы или цифры.',
  driveNameSuggestions: 'Свободны:',
  driveDescription: 'Описание (необязательно)',
  governance: 'Диск для',
  curatorOptIn: 'Назначить меня Менеджером библиотеки',
  workspace: 'Рабочее пространство',
  teamGoverned: 'Команда',
  projectGoverned: 'Проект',
  selectTeam: 'Выберите команду',
  selectProject: 'Выберите проект',
  projectVisibility: 'Видимость проекта',
  assignedMembers: 'Назначенные участники',
  workspaceVisible: 'Видно в рабочем пространстве',
  customAudience: 'Особая аудитория',
  primaryProjectDrive: 'Сделать основным диском проекта',
  create: 'Создать',
  cancel: 'Отмена',
  loading: 'Загрузка дисков…',
  emptyTitle: 'Нет доступных дисков',
  emptyDescription: 'Создайте общий диск или запросите доступ у Менеджера.',
  openDrive: 'Открыть диск',
  settings: 'Настройки диска',
  members: 'Участники',
  links: 'Связи',
  permissions: 'Разрешения',
  workflow: 'Процесс',
  activity: 'Активность',
  storage: 'Хранилище',
  role: 'Роль',
  status: 'Статус',
  usage: 'Использовано хранилища',
  restrictedFolders: 'Ограниченные папки',
  guestManagement: 'Управление гостями',
  createFailed: 'Не удалось создать диск.',
  addMember: 'Добавить участника',
  removeMember: 'Удалить',
  selectMember: 'Выберите участника рабочего пространства',
  noDirectMembers: 'Прямых участников пока нет.',
  unknownMember: 'Неизвестный участник',
  loadMoreMembers: 'Загрузить ещё участников',
  memberAdded: 'Участник добавлен.',
  memberRemoved: 'Участник удалён.',
  membersFailed: 'Не удалось обновить участников диска.',
  managerOnly: 'Управлять участниками могут только Менеджеры диска.',
  linkType: 'Тип связи',
  selectLinkTarget: 'Выберите команду или проект',
  addLink: 'Добавить связь',
  removeLink: 'Удалить',
  noLinks: 'Этот диск не связан с командами или проектами.',
  unknownLink: 'Недоступный контекст',
  linkAdded: 'Связь диска добавлена.',
  linkRemoved: 'Связь диска удалена.',
  linksFailed: 'Не удалось обновить связи диска.',
  viewerDownloads: 'Разрешить скачивание читателям',
  publicLinksWorkspacePolicy:
    'Публичные ссылки по-прежнему регулируются политикой владельца пространства.',
  selectFolder: 'Выберите папку',
  restrict: 'Ограничить',
  removeRestriction: 'Удалить границу',
  boundaryCreated: 'Граница ограниченной папки создана.',
  boundaryRemoved: 'Граница ограниченной папки удалена.',
  createWorkflow: 'Создать процесс по умолчанию',
  workflowCreated: 'Процесс по умолчанию создан.',
  noWorkflows: 'Для этого диска процесс не настроен.',
  noActivity: 'На диске пока нет активности.',
  activityAccess: 'Доступ изменён',
  activityContent: 'Действия с контентом',
  activityWorkflow: 'Действия рабочего процесса',
  activityPublish: 'Действия публикации',
  activityGovernance: 'Настройки диска обновлены',
  activityRecovery: 'Действия восстановления',
  activitySecurity: 'Действия безопасности',
  activityAutomation: 'Действия агента',
  activityDrive: 'Диск обновлён',
  policyUpdated: 'Политика диска обновлена.',
  settingsFailed: 'Не удалось обновить настройки диска.',
  guestEmail: 'Электронная почта гостевой учётной записи',
  addGuest: 'Добавить гостя',
  guestAdded: 'Гость добавлен как комментатор.',
  guestFailed:
    'Не удалось добавить гостя. У него уже должна быть учётная запись IMAI.',
  guestExpiry:
    'Гостевой доступ по умолчанию истекает через 90 дней и ограничен ролью Участник.',
  recovery: 'Восстановление',
  contentAccessRequired: 'Требуется доступ к содержимому',
  recoveryDescription:
    'Назначьте нового Менеджера, не открывая и не просматривая содержимое диска.',
  replacementManager: 'Выберите нового Менеджера',
  assignManager: 'Назначить Менеджера',
  recoveryAssigned: 'Новый Менеджер назначен.',
  recoveryFailed: 'Не удалось назначить нового Менеджера.',
  publishToLibrary: 'Опубликовать на диске пространства',
  publish: 'Опубликовать',
  publishStarted: 'Создание управляемой копии в библиотеке началось.',
  publishFailed: 'Не удалось опубликовать этот файл.',
  noPublishableFiles: 'На этом диске нет файлов для публикации.',
  libraryCuratorRequired:
    'Для публикации требуется роль Менеджера контента библиотеки.',
} satisfies DriveManagementCopy;

export const viDriveManagementCopy = {
  description: 'Tệp dùng chung cho nhóm, dự án và cộng tác viên.',
  createDrive: 'Tạo ổ đĩa',
  createDriveTitle: 'Tạo ổ đĩa dùng chung',
  driveName: 'Tên ổ đĩa',
  driveNameHint: 'Tên ổ đĩa là duy nhất và trở thành đường dẫn thư mục dễ đọc.',
  driveNameTaken: 'Đã có ổ đĩa tên “{name}”.',
  driveNameReserved: '“{name}” là tên dành riêng. Hãy chọn tên khác.',
  driveNameInvalid: 'Hãy dùng chữ cái hoặc chữ số trong tên ổ đĩa.',
  driveNameSuggestions: 'Còn trống:',
  driveDescription: 'Mô tả (không bắt buộc)',
  governance: 'Drive dành cho',
  curatorOptIn: 'Chỉ định tôi làm Quản lý thư viện',
  workspace: 'Không gian làm việc',
  teamGoverned: 'Nhóm',
  projectGoverned: 'Dự án',
  selectTeam: 'Chọn nhóm',
  selectProject: 'Chọn dự án',
  projectVisibility: 'Khả năng hiển thị của dự án',
  assignedMembers: 'Thành viên được phân công',
  workspaceVisible: 'Hiển thị trong không gian làm việc',
  customAudience: 'Đối tượng tùy chỉnh',
  primaryProjectDrive: 'Đặt làm ổ đĩa chính của dự án',
  create: 'Tạo',
  cancel: 'Hủy',
  loading: 'Đang tải ổ đĩa…',
  emptyTitle: 'Không có ổ đĩa khả dụng',
  emptyDescription: 'Tạo ổ đĩa dùng chung hoặc yêu cầu Quản lý cấp quyền.',
  openDrive: 'Mở ổ đĩa',
  settings: 'Cài đặt ổ đĩa',
  members: 'Thành viên',
  links: 'Liên kết',
  permissions: 'Quyền',
  workflow: 'Quy trình',
  activity: 'Hoạt động',
  storage: 'Bộ nhớ',
  role: 'Vai trò',
  status: 'Trạng thái',
  usage: 'Bộ nhớ đã dùng',
  restrictedFolders: 'Thư mục bị hạn chế',
  guestManagement: 'Quản lý khách',
  createFailed: 'Không thể tạo ổ đĩa.',
  addMember: 'Thêm thành viên',
  removeMember: 'Xóa',
  selectMember: 'Chọn thành viên không gian làm việc',
  noDirectMembers: 'Chưa có thành viên trực tiếp.',
  unknownMember: 'Thành viên không xác định',
  loadMoreMembers: 'Tải thêm thành viên',
  memberAdded: 'Đã thêm thành viên.',
  memberRemoved: 'Đã xóa thành viên.',
  membersFailed: 'Không thể cập nhật thành viên ổ đĩa.',
  managerOnly: 'Chỉ Quản lý ổ đĩa mới có thể quản lý thành viên.',
  linkType: 'Loại liên kết',
  selectLinkTarget: 'Chọn nhóm hoặc dự án',
  addLink: 'Thêm liên kết',
  removeLink: 'Xóa',
  noLinks: 'Ổ đĩa này không có liên kết nhóm hoặc dự án.',
  unknownLink: 'Ngữ cảnh không khả dụng',
  linkAdded: 'Đã thêm liên kết ổ đĩa.',
  linkRemoved: 'Đã xóa liên kết ổ đĩa.',
  linksFailed: 'Không thể cập nhật liên kết ổ đĩa.',
  viewerDownloads: 'Cho phép Người xem tải xuống',
  publicLinksWorkspacePolicy:
    'Liên kết công khai vẫn tuân theo chính sách của chủ sở hữu không gian làm việc.',
  selectFolder: 'Chọn thư mục',
  restrict: 'Hạn chế',
  removeRestriction: 'Xóa ranh giới',
  boundaryCreated: 'Đã tạo ranh giới thư mục hạn chế.',
  boundaryRemoved: 'Đã xóa ranh giới thư mục hạn chế.',
  createWorkflow: 'Tạo quy trình mặc định',
  workflowCreated: 'Đã tạo quy trình mặc định.',
  noWorkflows: 'Chưa cấu hình quy trình cho ổ đĩa này.',
  noActivity: 'Chưa có hoạt động ổ đĩa.',
  activityAccess: 'Đã thay đổi quyền truy cập',
  activityContent: 'Hoạt động nội dung',
  activityWorkflow: 'Hoạt động quy trình',
  activityPublish: 'Hoạt động xuất bản',
  activityGovernance: 'Đã cập nhật cài đặt Drive',
  activityRecovery: 'Hoạt động khôi phục',
  activitySecurity: 'Hoạt động bảo mật',
  activityAutomation: 'Hoạt động tác nhân',
  activityDrive: 'Đã cập nhật ổ đĩa',
  policyUpdated: 'Đã cập nhật chính sách ổ đĩa.',
  settingsFailed: 'Không thể cập nhật cài đặt ổ đĩa.',
  guestEmail: 'Email tài khoản khách',
  addGuest: 'Thêm khách',
  guestAdded: 'Đã thêm khách với vai trò Người bình luận.',
  guestFailed: 'Không thể thêm khách này. Họ phải có sẵn danh tính IMAI.',
  guestExpiry:
    'Quyền truy cập của khách mặc định hết hạn sau 90 ngày và tối đa là Cộng tác viên.',
  recovery: 'Khôi phục',
  contentAccessRequired: 'Cần quyền truy cập nội dung',
  recoveryDescription:
    'Chỉ định Quản lý thay thế mà không mở hoặc xem nội dung ổ đĩa.',
  replacementManager: 'Chọn Quản lý thay thế',
  assignManager: 'Chỉ định Quản lý',
  recoveryAssigned: 'Đã chỉ định Quản lý thay thế.',
  recoveryFailed: 'Không thể chỉ định Quản lý thay thế.',
  publishToLibrary: 'Xuất bản lên ổ đĩa workspace',
  publish: 'Xuất bản',
  publishStarted: 'Đã bắt đầu tạo bản sao thư viện được quản lý.',
  publishFailed: 'Không thể xuất bản tệp này.',
  noPublishableFiles: 'Ổ đĩa này không có tệp để xuất bản.',
  libraryCuratorRequired: 'Cần quyền Quản lý nội dung thư viện để xuất bản.',
} satisfies DriveManagementCopy;
